import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'myfilter',
    pure: false,
    standalone: false
})
export class myFilterPipe implements PipeTransform {
    transform(items: any[], callback: (item: any) => boolean): any {
        if (!items || !callback) {
            return items;
        }
        return items.filter(item => callback(item));
    }
}